export const SHIPPING_THRESHOLD = 80000;

export const CATEGORY_LABELS = {
  elektromos: 'Elektromos kerékpár',
  tura: 'Túrakerékpár',
  varosi: 'Városi kerékpár',
  gyermek: 'Gyermekkerékpár',
};
